import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function changeBackgroundColor() {
    gsap.to('.home .transparent-navbar', {
        backgroundColor: '#ffffff',
        scrollTrigger: {
            start: 0,
            end: 100,
            scrub: true,
        },
    });
}

function changeNavLinksOnScroll() {
    gsap.to('.nav-link', {
		color: '#000000',
        scrollTrigger: {
            start: 0,
            end: 100,
            scrub: true,
        },
    });
}

function changeSocialNavBrightnessOnScroll() {
    gsap.to('.social-nav .nav-link', {
        filter: 'brightness(0)',
        scrollTrigger: {
            start: 0,
            end: 100,
            scrub: true,
        },
    });
}

function hideNavbartoggleOnScroll() {
	if (window.innerWidth >= 992) { // Bootstrap's lg breakpoint
		gsap.fromTo('.navbar-toggler',
			{ opacity: 0, visibility: 'hidden' },
			{
				opacity: 1,
				visibility: 'visible',
				scrollTrigger: {
					start: 0,
					end: 100,
					scrub: true,
				},
			}
		);
	}
}



export default function initNavScroll() {
    gsap.registerPlugin(ScrollTrigger);

    changeBackgroundColor();
	hideNavbartoggleOnScroll();
	changeNavLinksOnScroll();
changeSocialNavBrightnessOnScroll()
}




